import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Session persistante : si le jeton de session (60 min) est expiré, on le renouvelle
// silencieusement grâce au cookie de session longue durée (7 jours, glissant), puis on
// rejoue la requête d'origine. L'utilisatrice reste connectée après fermeture de l'app ;
// seule une déconnexion volontaire (ou 7 jours sans ouverture) termine la session.

let refreshPromise = null;

async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, null, { withCredentials: true, skipAuthRefresh: true })
      .then(({ data }) => {
        if (data?.access_token) localStorage.setItem("rav-token", data.access_token);
        return true;
      })
      .catch(() => false)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const url = config.url || "";
    const isAuthCall = /\/auth\/(login|register|refresh|logout|forgot|reset)/.test(url);
    if (error.response?.status === 401 && !isAuthCall && !config.skipAuthRefresh && !config.__retried) {
      config.__retried = true;
      const ok = await refreshSession();
      if (ok) {
        const token = localStorage.getItem("rav-token");
        config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
        return axios({ ...config, withCredentials: true });
      }
      // Session vraiment terminée : on efface le jeton local (l'app proposera la connexion)
      localStorage.removeItem("rav-token");
    }
    return Promise.reject(error);
  },
);

// À l'ouverture de l'app : si un jeton existe mais est expiré, on le rafraîchit tout de suite
// pour que la session soit prête avant le premier écran.
export async function warmSession() {
  if (!localStorage.getItem("rav-token")) return;
  await refreshSession();
}
